import { customAxios } from './customAxios';

export async function getDetailAttachments(ids) {
    const config = {
        headers: {
            Accept: '*/*',
            'Content-Type': 'application/json',
            'AuthToken': JSON.parse(localStorage.getItem('token')),
        },
    };
    try {
        const response = await customAxios.post(`${process.env.REACT_APP_BACKEND_HOST}/adv/badpress/detail-attachments`, ids, config);
        return response.data;
    } catch (error) {
        console.error('Errore nel recupero del dettaglio degli attachment:', error);
        throw error;
    }
}
